import PptxGenJS from "pptxgenjs";

export const coverPage = (pptx: PptxGenJS, data: any) => {
    console.log({ data })
    const slide = pptx.addSlide();
    slide.background = { color: '000000' };

    // Top Header Bar
    slide.addShape('rect', {
        x: 0,
        y: 0,
        w: '100%',
        h: 0.8,
        fill: { color: 'FFFFFF' },
        line: { type: 'none' }
    });

    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });

    // Orange accent bar on the right side - adjusted for A4 width (8.27)
    slide.addShape('rect', {
        x: 7.97,
        y: 4.5,
        w: 0.3,
        h: 2.5,
        fill: { color: 'FF6600' },
        line: { type: 'none' }
    });

    // Main Title - Centered for A4 (width 8.27)
    const displayTitle = data?.surveyTitle || '360-Degree Feedback Report';
    slide.addText(displayTitle, {
        x: 0,
        y: 4.0,
        w: '100%',
        h: 1.0,
        fontSize: displayTitle.length > 30 ? 24 : 34,
        bold: true,
        color: 'FFFFFF',
        align: 'center',
        valign: 'middle'
    });

    const candidateName = data?.candidateName || 'Jane Doe';

    slide.addText(candidateName, {
        x: 0,
        y: 5.0,
        w: '100%',
        h: 0.6,
        fontSize: 30,
        color: 'FFFFFF',
        align: 'center',
        valign: 'middle'
    });

    const reportDate =
        data?.date ||
        new Date().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });

    slide.addText(reportDate, {
        x: 0,
        y: 5.7,
        w: '100%',
        h: 0.4,
        fontSize: 14,
        color: 'CCCCCC',
        align: 'center',
        valign: 'middle'
    });

    // Footer at the bottom of A4 (Height 11.69)
    slide.addShape('rect', {
        x: 0,
        y: 11.0,
        w: '100%',
        h: 0.6,
        fill: { color: 'FF6600' },
        line: { type: 'none' }
    });

    slide.addText('360-Degree Feedback Individual Report — Confidential', {
        x: 0,
        y: 11.15,
        w: '100%',
        h: 0.3,
        fontSize: 10,
        color: 'FFFFFF',
        align: 'center'
    });
}